import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    getWidgetsConfig: ({state, getters, commit, dispatch}, widget: any) => {

        return new Promise((resolve, reject) => {

            axios.get('/dashboard/widgets')

                .then(({data}) => {
                    commit('setWidgetsConfig', data.widgets);
                    resolve(null);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    updateWidget: ({state, getters, commit, dispatch}, widget: any) => {

        commit('updateWidget', widget);

        return new Promise((resolve, reject) => {

            axios.put('/dashboard/widget', widget)

                .then(() => {
                    resolve(null);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    updateWidgetsOrder: ({state, getters, commit, dispatch}, order: Array<number>) => {

        return new Promise((resolve, reject) => {

            axios.post('/dashboard/widgets/order', {order: order})

                .then(() => {
                    resolve(null);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    getPanelSizeStats: ({state, getters, commit, dispatch}, force: boolean) => {

        if (force) state.panelSizeStatsExpire = null;

        return new Promise((resolve, reject) => {

            if (state.panelSizeStatsExpire && moment().isBefore(state.panelSizeStatsExpire)) {
                resolve(null);
            } else {
                axios.get('/dashboard/panel/growth?limit=12')

                    .then(({data}) => {

                        commit('setPanelSizeStats', data.items);
                        resolve(null);
                    })
                    .catch(error => {

                        reject(error);
                    });
            }
        });
    },

    getProjectActivityStatsDaily: ({state, getters, commit, dispatch}, force: boolean) => {

        if (force) state.projectActivityStatsExpire = null;

        return new Promise((resolve, reject) => {

            if (state.projectActivityStatsExpire && moment().isBefore(state.projectActivityStatsExpire)) {
                resolve(null);
            } else {
                axios.get('/dashboard/stats/activity?type=daily&limit=14')

                    .then(({data}) => {
                        commit('setProjectActivityStats', data.items);
                        resolve(null);
                    })
                    .catch(error => {

                        reject(error);
                    });
            }
        });
    },

    getProjectActivityStatsForLastHour: ({state, getters, commit, dispatch}, force) => {

        if (force) state.projectActivityStatsHourExpires = null;

        return new Promise((resolve, reject) => {

            if (state.projectActivityStatsHourExpires && moment().isBefore(state.projectActivityStatsHourExpires)) {
                resolve(state.projectActivityStatsHour);
            } else {
                axios.get('/dashboard/projects/stats/activity')

                    .then((response) => {

                        commit('setProjectActivityStatsForLastHour', response.data.project);
                        resolve(response.data);
                    })
                    .catch(error => {

                        reject(error);
                    });
            }
        });
    },

    getStatusPredictions: ({state, getters, commit, dispatch}, {force, type}) => {

        if (force) state.statusPredictionsExpire = null;

        return new Promise((resolve, reject) => {

            if (state.statusPredictionsExpire && moment().isBefore(state.statusPredictionsExpire)) {
                resolve(state.statusPredictions);
            } else {
                axios.get('/dashboard/panel/statuses/predict?type=' + type)

                    .then((response) => {

                        commit('setStatusPredictions', {
                            current: response.data.current,
                            predictions: response.data.predictions,
                            predictionTrends: response.data.predictionTrends
                        });

                        resolve(response.data);
                    })
                    .catch(error => {

                        reject(error);
                    });
            }
        });
    },
};
